import { ILocation } from '@models/interfaces/ILocation';
import { DefaultLocationFormatter } from '../default-location-formatter';

export class PnLocationFormatter extends DefaultLocationFormatter {
  format(location: ILocation): string[] {
    const streetName = `${location.StreetNumber} ${location.PlaceName}`.trim();
    const city = `${location.Zip} ${location.CityName}`.trim();

    return [[streetName, city].filter(s => s).join(', ')];
  }
}
